import { Action, any, IOWidget, Pair } from 'widgets-for-react';
import { fromJSX } from '../../../../../utils';
import { CustomRouteParams } from '../../../../cms/router/type.gen';
import { emptyAppState, PublicSiteState } from '../../../../public_site.main.mod';
import { WordPressBlockImagesLoader } from '../../../../wordpress/rendering/image_utils.mod';
import { WordPressBlock_To_WidgetBlock } from '../../../../wordpress/wordpress_to_cms.gen';
import { notfound_page } from '../../../templates/error_page.mod';
import { loader } from '../../../templates/loader.mod';
import { page } from '../../../templates/page.mod';
import { CustomPagesState, PublicSiteCustomRoutes } from '../../types.mod';
import { CustomBlock_To_Widget } from '../../../CustomBlockToWidget'
import { PageTemplateComponent } from '../../../../cms/page/widget.gen';
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen';
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.mod';
import { CustomBlockData } from '../../../blocks/custom_blocks/types.mod';
import { ExtraImages } from '../../../utils/extra_images.mod';
import { PublicSite_CustomPageData } from '../../../application.mod';
import { TemplateState } from '../../../../cms/page/types.gen';



export let storyDetailWidget = (r: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>): IOWidget<CustomPagesState['Fc150YearsMainPage'], Action<CustomPagesState['Fc150YearsMainPage']>> =>
  s0 => any<Action<CustomPagesState['Fc150YearsMainPage']>>()([
    fromJSX(setState => {

      let global_state: PublicSiteState = {
        ...emptyAppState(page),
        page: r.snd.state.page,
        Fc150YearsMainPage: s0
      }

      let template_props = {
        StandardBlockImagesLoader: WordPressBlockImagesLoader,
        StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
        errorPage: notfound_page,
        loadingPage: loader,
        CustomBlock_To_Widget,
        CustomBlockImagesLoader: () => []
      }


      return PageTemplateComponent<Block, CustomBlock, CustomBlockData, ExtraImages, PublicSite_CustomPageData, PublicSiteState>({
        pageDisplay: p => global_state.page.pagedisplay(p, global_state),
        Display: b => global_state.page.display(b),
        CustomBlock_To_Widget: template_props.CustomBlock_To_Widget,
        CustomBLockImagesLoader: template_props.CustomBlockImagesLoader,
        StandardBlockImagesLoader: template_props.StandardBlockImagesLoader,
        StandardBlock_To_Widget: template_props.StandardBlock_To_Widget,
        errorPage: template_props.errorPage(global_state),
        loadingPage: template_props.loadingPage
      }, global_state)({
        blocks: global_state.page.blocks,
        images: global_state.page.images,
        custom_page_data: global_state.page.custom_page_data,
        page: global_state.page.page
      } as TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>).map<Action<PublicSiteState>>(a => s3 => {
        return { ...s3, page: { ...s3.page, ...a(s3.page) } };
      }).run(a => {
        setState(res1 => {
          let state1 = a({ ...global_state, page: res1.state.page })
          return { ...res1, state: state1 }
        })
      })
    })
  ])